import {
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { QuestionTypeEnum } from "services/KnowfullyAdminClient";

type CredentialQuestionFieldProps = {
  label: string;
  type: QuestionTypeEnum;
  value: string;
  required?: boolean;
  answerId?: string;
  choices?: { id?: string; value?: string }[];
  validationPattern?: string;
  validationMessage?: string;
  onChange: (value: string, answerId?: string) => void;
};

const CredentialQuestionField = ({
  label,
  type,
  value,
  required,
  answerId,
  choices,
  validationPattern,
  validationMessage,
  onChange,
}: CredentialQuestionFieldProps) => {
  switch (type) {
    case QuestionTypeEnum.MultiLineTextInput:
      return (
        <TextField
          variant="standard"
          label={label}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          fullWidth
          multiline
          minRows={2}
        />
      );

    case QuestionTypeEnum.SingleSelect:
    case QuestionTypeEnum.LookupQuestion:
    case QuestionTypeEnum.CreatableSingleSelect:
      return (
        <TextField
          variant="standard"
          label={label}
          value={answerId ?? ""}
          onChange={(e) => {
            const selected = choices?.find((c) => c.id === e.target.value);
            onChange(selected?.value ?? "", e.target.value);
          }}
          required={required}
          fullWidth
          select
        >
          <MenuItem value="">-</MenuItem>
          {choices?.map((choice) => (
            <MenuItem key={choice.id} value={choice.id}>
              {choice.value}
            </MenuItem>
          ))}
        </TextField>
      );

    case QuestionTypeEnum.TwoOptionsRadioButton:
      return (
        <FormControl>
          <FormLabel>{label}</FormLabel>
          <RadioGroup
            row
            value={answerId ?? ""}
            onChange={(e) => {
              const selected = choices?.find((c) => c.id === e.target.value);
              onChange(selected?.value ?? "", e.target.value);
            }}
          >
            {choices?.map((choice) => (
              <FormControlLabel
                key={choice.id}
                value={choice.id}
                control={<Radio />}
                label={choice.value ?? ""}
              />
            ))}
          </RadioGroup>
        </FormControl>
      );

    case QuestionTypeEnum.Date:
      return (
        <TextField
          variant="standard"
          label={label}
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      );

    case QuestionTypeEnum.SingleLineTextInput:
    default:
      return (
        <TextField
          variant="standard"
          label={label}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          fullWidth
          inputProps={
            validationPattern ? { pattern: validationPattern } : undefined
          }
          helperText={validationMessage}
        />
      );
  }
};

export default CredentialQuestionField;
